import { type TPrice as TApiPrice } from '@core/api'

import { type TPrice } from '@core/models'

export const convertPrice = (price: TApiPrice): TPrice => {
    const { currency, period, value, final_value, coupon_name, coupon_value, is_trial } = price

    return {
        currency,
        period,
        value,
        finalValue: final_value,
        couponName: coupon_name,
        couponValue: coupon_value,
        isTrial: is_trial,
    }
}
